import {combineReducers} from 'redux';
import {historyReducer} from './history/reducer';
import {offersReducer} from './offers/reducer';

export const baseReducer = combineReducers({
    list_history: historyReducer,
    offers: offersReducer,
});